export const getSizeStyles = (size) => {
    switch (size) {
        case "sm":
            return { fontSize: "xs", px: 2.5, h: 8, minH: 8 };
        case "md":
            return { fontSize: "sm", px: 3, h: 10, minH: 10 };
        case "lg":
            return { fontSize: "md", px: 4, h: 12, minH: 12 };
        default:
            return { fontSize: "sm", px: 3, h: 10, minH: 10 };
    }
};
